import "./DefaultSelect.scss";
import React, { useState, useEffect } from "react";
import { useDetectClickOutside } from "react-detect-click-outside";

import arrowIcon from "assets/icons/arrow-down.svg";

interface Props {
  value?: string | number;
  placeholder?: string | number;
  label?: string;
  disabled?: boolean;
  options: {
    value: string | number;
    label: string;
  }[];
  onSelect: (e: string | number) => void;
  isSmall?: boolean;
}

const DefaultSelect: React.FC<Props> = ({
  value,
  label,
  placeholder,
  options,
  onSelect,
  disabled,
  isSmall,
}) => {
  const [dropdownOpened, setDropdownOpened] = useState<boolean>(false);
  const [currentItem, setCurrentItem] = useState<{
    value: string | number;
    label: string;
  }>();

  useEffect(() => {
    setCurrentItem(options.filter((el) => el.value === value)[0]);
  }, [options, value]);

  const handleChange = (e: string | number) => {
    onSelect(e);
  };
  const handleToggle = () => {
    setDropdownOpened(!dropdownOpened);
  };

  const ref = useDetectClickOutside({
    onTriggered: () => {
      setDropdownOpened(false);
    },
  });

  return (
    <div
      ref={ref}
      className={`
    default-select
    ${isSmall ? "default-select--small" : ""}
    ${label ? "default-select--with-label" : ""}
    ${dropdownOpened ? "default-select--opened" : ""}
  `}
    >
      {/* {label && <div className="default-select__label">{label}</div>} */}

      <div
        className={`
      default-select__select
      ${disabled ? "default-select__select--disabled" : ""}
      ${dropdownOpened ? "default-select__select--opened" : ""}
    `}
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled) handleToggle();
        }}
      >
        <span title={currentItem?.label}>
          {currentItem?.label ?? placeholder ?? label}
        </span>
        <img src={arrowIcon} alt="arrow" />
      </div>

      <div className="default-select__content">
        {options.map((el) => (
          <div
            key={el.value}
            title={el.label}
            className={`
          default-select__item
          ${
            String(value) === String(el.value)
              ? "default-select__item--active"
              : ""
          }
        `}
            onClick={() => {
              if (!disabled) {
                handleChange(el.value);
                handleToggle();
              }
            }}
          >
            {el.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DefaultSelect;
